<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :title="reported ? '维修检测报告' : '新增维修检测报告'"
      :close-on-click-modal="false"
      top="1vh"
      width="1100px"
      class="CheckReport"
      @close="checkReport = $options.data().checkReport; visualInspectionList = []">
    <div id="printContent" v-loading="contentLoading">
      <div class="table">
        <table>
          <tr>
            <td colspan="6">
              <div style="width:20%;float: left;" class="img">
                <img style="width:100%" src="../../../../public/img/stepIcon.png" alt="">
              </div>
              <div style="width:65%;line-height:55px;float: left;font-size:40px;font-weight:700;text-align:center;color: #333;">
                检测报告
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="6" style="padding: 0">
              <table style="width: 100%">
                <tr>
                  <td class="subTitle" style="border:none; width: 14.1%">维修登记编号</td>
                  <td class="record" style="border-block: none; width: 13.9%">{{checkReport.billNo}}</td>
                  <!--                  <td class="subTitle" style="border-block: none; width: 11%">测试人员</td>-->
                  <!--                  <td class="record" style="border-block: none; width: 14%">{{checkReport.creatorName}}</td>-->
                  <!--                  <td class="subTitle" style="border-block: none; width: 11%">测试地点</td>-->
                  <!--                  <td class="record" style="border-block: none; width: 11%">维修组</td>-->
                  <td class="subTitle" style="border-block: none; width: 11%">编辑人</td>
                  <td class="record" style="border: none; width: 14%">
                    <el-input
                        v-if="!isPrint"
                        v-model="checkReport.editor"
                        :disabled="disabled"
                        clearable/>
                    <span v-else>{{checkReport.editor}}</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="6" style="font-size: 13px; font-weight: 700;color: #000;">◈相关信息</td>
          </tr>
          <tr>
            <td class="subTitle" style="width: 14.1%">客户名称</td>
            <td class="record">{{checkReport.customerName}}</td>
            <td class="subTitle">客户单号</td>
            <td style="width: 15%" class="record">{{checkReport.customerOrderNo}}</td>
            <td class="subTitle">售后单号</td>
            <td style="width: 15%" class="record">{{checkReport.afterSaleOrderNo}}</td>
          </tr>
          <tr>
            <!--            <td class="subTitle">整机条码</td>-->
            <!--            <td class="record">{{checkReport.receiveSn}}</td>-->
            <td class="subTitle">物料号</td>
            <td style="width: 15%" class="record">{{checkReport.receiveMaterialNo}}</td>
            <td class="subTitle">生产厂家</td>
            <td style="width: 15%" class="record">
              <el-input
                  v-if="!isPrint"
                  v-model="checkReport.manufacturer"
                  :disabled="disabled"
                  clearable/>
              <span v-else>{{checkReport.manufacturer}}</span>
            </td>
          </tr>
          <tr>
            <td class="subTitle">物料描述</td>
            <td colspan="3" class="record">{{checkReport.receiveMaterialName}}</td>
            <td class="subTitle">检测数量</td>
            <td style="width: 15%" class="record">{{checkReport.quantity}}</td>
          </tr>
          <tr>
            <td class="subTitle">部件条码</td>
            <td colspan="5" class="record" style="padding: 0">
              <table v-if="checkReport.originPartList.length > 0" style="width: 100%">
                <tr>
                  <td style="width: max-content; text-align: center; border-top: none; border-left: none; border-bottom: none">原部件条码</td>
                  <td style="width: 16%; text-align: center; border-top: none; border-bottom: none">原部件物料号</td>
                  <td style="text-align: center; border-top: none; border-right: none; border-bottom: none">原部件物料描述</td>
                  <td style="width: 16%; text-align: center; border-block: none; border-right: none">部件信息</td>
                </tr>
                <tr v-for="(item, index) in checkReport.originPartList" :key="index">
                  <td style="text-align: center; border-left: none; border-bottom: none">{{item.originPartSn}}</td>
                  <td style="text-align: center; border-bottom: none">{{item.originPartMaterialNo}}</td>
                  <td style="border-bottom: none; border-right: none">{{item.originPartMaterialName}}</td>
                  <td style="border-bottom: none; border-right: none">{{item.originPartInfo}}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
<!--            <td class="subTitle">售后申请时间</td>-->
<!--            <td class="record">{{checkReport.demandAfterSaleTime}}</td>-->
            <td class="subTitle">接收时间</td>
            <td class="record">
              <el-date-picker
                  v-if="!isPrint"
                  v-model="checkReport.receiptTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"/>
              <span v-else>{{checkReport.receiptTime}}</span>
            </td>
            <td class="subTitle">检测日期</td>
            <td class="record">{{checkReport.repairDate}}</td>
          </tr>
          <tr>
            <td class="subTitle">故障描述</td>
            <td colspan="5" class="record">{{checkReport.siteDesc}}</td>
          </tr>
          <tr>
            <td colspan="6" style="font-size: 13px; font-weight: 700;color: #000;">◈检查项目</td>
          </tr>
          <tr>
            <td rowspan="2" class="subTitle">外观检查</td>
            <td colspan="5" class="record">
              <el-checkbox-group v-if="!isPrint" v-model="visualInspectionList" :disabled="disabled" @change="visualInspectionSelect">
                <el-checkbox label="烧焦"/>
                <el-checkbox label="进水"/>
                <el-checkbox label="破损"/>
                <el-checkbox label="附件遗失"/>
                <el-checkbox label="端子损坏"/>
                <el-checkbox label="其他"/>
                <el-checkbox label="外观无损坏"/>
              </el-checkbox-group>
              <span v-else>
                <span v-if="checkReport.visualInspection !== null && checkReport.visualInspection.includes('烧焦')">☑</span>
                <span v-else>□</span>
                烧焦
                <span v-if="checkReport.visualInspection !== null && checkReport.visualInspection.includes('进水')">☑</span>
                <span v-else>□</span>
                进水
                <span v-if="checkReport.visualInspection !== null && checkReport.visualInspection.includes('破损')">☑</span>
                <span v-else>□</span>
                破损
                <span v-if="checkReport.visualInspection !== null && checkReport.visualInspection.includes('附件遗失')">☑</span>
                <span v-else>□</span>
                附件遗失
                <span v-if="checkReport.visualInspection !== null && checkReport.visualInspection.includes('端子损坏')">☑</span>
                <span v-else>□</span>
                端子损坏
                <span v-if="checkReport.visualInspection !== null && checkReport.visualInspection.includes('其他')">☑</span>
                <span v-else>□</span>
                其他
                <span v-if="checkReport.visualInspection !== null && checkReport.visualInspection.includes('外观无损坏')">☑</span>
                <span v-else>□</span>
                外观无损坏
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="record">
              备注：
              <el-input v-if="!isPrint" v-model="checkReport.visualInspectionNote" :disabled="disabled" type="textarea"/>
              <span v-else>{{checkReport.visualInspectionNote}}</span>
            </td>
          </tr>
          <!--          <tr>-->
          <!--            <td class="subTitle">数据信息</td>-->
          <!--            <td colspan="5" class="record">-->
          <!--              <div style="display: flex; justify-content: space-evenly">-->
          <!--                <span>上电时间/分钟：{{checkReport.powerOnTime !== null ? checkReport.powerOnTime : ""}}</span>-->
          <!--                <span>运行时间/分钟：{{checkReport.runTime !== null ? checkReport.runTime : ""}}</span>-->
          <!--                <span>散热器最高温度：{{checkReport.radiatorTemperature !== null ? checkReport.radiatorTemperature : ""}}</span>-->
          <!--                <span>故障代码：{{checkReport.faultCode !== null ? checkReport.faultCode : ""}}</span>-->
          <!--              </div>-->
          <!--            </td>-->
          <!--          </tr>-->
          <tr>
            <td rowspan="3" class="subTitle">性能检查</td>
            <td colspan="5" class="record">
              <el-radio-group v-if="!isPrint" v-model="checkReport.checkAbnormal" :disabled="disabled">
                <el-radio :label="false">性能检查正常</el-radio>
                <el-radio :label="true">性能检查异常</el-radio>
              </el-radio-group>
              <span v-else>
                <span v-if="checkReport.checkAbnormal === false">☑</span>
                <span v-else>□</span>
                性能检查正常
                <span v-if="checkReport.checkAbnormal === true">☑</span>
                <span v-else>□</span>
                性能检查异常
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="record">
              异常描述:
              <el-input v-if="!isPrint" v-model="checkReport.abnormalDesc" :disabled="disabled" type="textarea"/>
              <span v-else>{{checkReport.abnormalDesc}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="record" style="padding: 0">
              <table style="width: 100%">
                <!--                <tr>-->
                <!--                  <td colspan="2" style="width: 25%; text-align: center; border-block: none; border-left: none">部件条码</td>-->
                <!--                  <td style="width: 16%; text-align: center; border-top: none; border-bottom: none">部件物料号</td>-->
                <!--                  <td style="text-align: center; border-top: none; border-right: none; border-bottom: none">部件物料描述</td>-->
                <!--                  <td style="width: 16%; text-align: center; border-top: none; border-right: none; border-bottom: none">检测现象</td>-->
                <!--                </tr>-->
                <!--                <template v-for="(item, index) in checkReport.partList">-->
                <!--                  <tr :key="index">-->
                <!--                    <td colspan="2" style="text-align: center; border-left: none; border-bottom: none">{{item.partSn}}</td>-->
                <!--                    <td style="text-align: center; border-bottom: none">{{item.partMaterialNo}}</td>-->
                <!--                    <td style="border-bottom: none;">{{item.partMaterialName}}</td>-->
                <!--                    <td style="border-bottom: none; border-right: none">{{item.inspectionMethod}}</td>-->
                <!--                  </tr>-->
                <!--                  <tr v-if="item.componentList.length > 0" :key="index">-->
                <!--                    <td style="width: 8%; text-align: center; border-left: none">元件位号</td>-->
                <!--                    <td style="text-align: center; border-left: none">元件物料号</td>-->
                <!--                    <td style="text-align: center; border-right: none; border-bottom: none">所属电气网络</td>-->
                <!--                    <td style="text-align: center; border-bottom: none">元件物料描述</td>-->
                <!--                    <td style="text-align: center; border-right: none; border-bottom: none">失效模式</td>-->
                <!--                  </tr>-->
                <!--                  <tr v-for="(component, componentIndex) in item.componentList" :key="componentIndex">-->
                <!--                    <td style="text-align: center; border-left: none; border-bottom: none">{{component.componentNo}}</td>-->
                <!--                    <td style="text-align: center; border-left: none; border-bottom: none">{{component.componentMaterialNo}}</td>-->
                <!--                    <td style="border-bottom: none;">{{component.electricNetwork}}</td>-->
                <!--                    <td style="border-bottom: none">{{component.componentMaterialName}}</td>-->
                <!--                    <td style="border-bottom: none; border-right: none">{{component.failureModes}}</td>-->
                <!--                  </tr>-->
                <!--                </template>-->
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="6" style="font-size: 13px; font-weight: 700;color: #000;">◈分析结论</td>
          </tr>
          <tr>
            <td rowspan="2" class="subTitle">分析结果</td>
            <td colspan="5" class="record">
              原因分析：
              <el-input v-if="!isPrint" v-model="checkReport.causeInvestigation" :disabled="disabled" type="textarea"/>
              <span v-else>{{checkReport.causeInvestigation}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="record">
              责任判断：
              <template>
                <el-radio-group v-if="!isPrint" v-model="checkReport.responsibleDecision" :disabled="disabled">
                  <el-radio label="客户责任"/>
                  <el-radio label="供应商责任"/>
                  <el-radio label="其他"/>
                </el-radio-group>
                <span v-else>
                  <span v-if="checkReport.responsibleDecision === '客户责任'">☑</span>
                  <span v-else>□</span>
                  客户责任
                  <span v-if="checkReport.responsibleDecision === '供应商责任'">☑</span>
                  <span v-else>□</span>
                  供应商责任
                  <span v-if="checkReport.responsibleDecision === '其他'">☑</span>
                  <span v-else>□</span>
                  其他
                </span>
              </template>
            </td>
          </tr>
        </table>
      </div>
      <div class="footTable" style="page-break-inside: avoid">
        <table>
          <tr>
            <td style="font-size: 13px; font-weight:700; color:#000">
              ◈检验附件
            </td>
          </tr>
          <tr v-if="!checkReport.attachments || !checkReport.attachments.length">
            <td>暂无附件</td>
          </tr>
          <tr v-for="(attachments, index) in attachmentList" :key="index">
            <td v-for="(item, subIndex) in attachments" :key="subIndex">
              <el-image
                  style="width: 100%; height: 300px"
                  :src="getPhotoPath(item)"
                  fit="contain"
                  :preview-src-list="[getPhotoPath(item)]"/>
            </td>
            <td v-if="attachments.length === 1"/>
          </tr>
        </table>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!isPrint" type="primary" style="margin-left:5px" @click="saveReport">保存</el-button>
      <el-button :disabled="contentLoading" type="success" style="margin-left:5px" @click="print">打印</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "RepairRegistrationReport",
    data() {
      return {
        dialogVisible: false,
        isPrint: false,
        disabled: false,
        contentLoading: false,
        reported: true,
        attachmentList: [],
        visualInspectionList: [],
        checkReport: {
          masterId: "",
          billNo: "",
          editor: "",
          manufacturer: "",
          demandAfterSaleTime: "",
          receiptTime: "",
          visualInspection: "",
          visualInspectionNote: "",
          checkAbnormal: "",
          abnormalDesc: "",
          causeInvestigation: "",
          responsibleDecision: "",
          creatorName: "",
          customerName: "",
          customerOrderNo: "",
          afterSaleOrderNo: "",
          receiveSn: "",
          receiveMaterialNo: "",
          receiveMaterialName: "",
          quantity: "",
          repairDate: "",
          siteDesc: "",
          powerOnTime: "",
          runTime: "",
          radiatorTemperature: "",
          faultCode: "",
          partList: [],
          originPartList: [],
          attachments: [],
        },
      };
    },
    methods: {
      open(row, master, reported, disabled) {
        this.reported = reported;
        this.isPrint = !!disabled;
        this.dialogVisible = true;
        this.getData(row, master);
      },
      getData(row, master) {
        this.contentLoading = true;
        let url;
        if (master) {
          url = "repairRegistrationReports/record/" + row.id;
        } else {
          url = "repairRegistrationReports/" + row.id;
        }
        this.$http
          .get("basic", url)
          .then(resp => {
            this.checkReport = resp;
            this.visualInspectionList = this.checkReport.visualInspection ? this.checkReport.visualInspection.split(",") : [];
            if (master) {
              this.checkReport.masterId = row.id;
            }
            this.attachmentList = [];
            let array = [];
            console.log(this.checkReport.attachments);
            this.checkReport.attachments.forEach(item => {
              if (array.length === 0) {
                this.attachmentList.push(array);
              }
              array.push(item);
              if (array.length === 2) {
                array = [];
              }
            });
            console.log(this.attachmentList);
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      print() {
        this.isPrint = true;
        if (this.disabled) {
          document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
          window.print();
          window.location.reload();
          this.isPrint = false;
        } else {
          this.$http.post("basic", "repairRegistrationReports", this.checkReport).then(() => {
            document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
            window.print();
            window.location.reload();
            this.isPrint = false;
          });
        }
      },
      saveReport() {
        this.$http.post("basic", "repairRegistrationReports", this.checkReport).then(() => {
          this.reported = true;
          this.$emit("save-success");
          this.$message.success("保存成功");
        });
      },
      getPhotoPath(row) {
        let imgUrl = "";
        if(row.filePath.includes("common")) {
          imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        }else {
          imgUrl = "http://emes.stepelectric.com" + row.filePath;
        }
        return imgUrl;
      },
      visualInspectionSelect() {
        this.checkReport.visualInspection = this.visualInspectionList.length > 0 ? this.visualInspectionList.join(",") : "";
      },
    },
  };
</script>

<style lang="scss" scoped>
.CheckReport {
  width: 100%;
}

.table {
  width: 100%;
}

.table .subTitle {
  width: 12%;
  font-size: 13px ;
  font-weight: 600;
}

.table .record {
  font-size: 12px;
}

.table table {
  width: 98%;
  border-collapse: collapse;
}

.table tr {
  width: 100%;
}

.table td {
  border: 1px solid #333;
  padding: 5px 10px;
}

.input .el-textarea__inner {
  height: 10vh;
  width: 98%;
}

.footTable table {
  width: 98%;
  margin-top: 5px;
  font-size: 12px;
  border-collapse: collapse;
  border: 1px solid #333;
}

.footTable table td {
  width: 50%;
  padding: 5px 10px;
}

::v-deep .el-checkbox__label {
  font-size: 12px;
}
::v-deep .el-checkbox__inner {
  width: 12px;
  height: 12px;
}
::v-deep .el-radio__label {
  font-size: 12px;
}
::v-deep .el-radio__inner {
  width: 12px;
  height: 12px;
}
</style>
